import React, { createContext, useContext, useState, useEffect } from 'react';

const CarritoContext = createContext();

export const CarritoProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('carrito') || '[]');
    } catch { return []; }
  });

  const [carritoAbierto, setCarritoAbierto] = useState(false);

  useEffect(() => {
    localStorage.setItem('carrito', JSON.stringify(items));
  }, [items]);

  const agregar = (producto, cantidad = 1) => {
    setItems(prev => {
      const existe = prev.find(i => i.id === producto.id);
      if (existe) {
        const nuevaCantidad = existe.cantidad + cantidad;
        if (nuevaCantidad > producto.stock) return prev;
        return prev.map(i => i.id === producto.id
          ? { ...i, cantidad: nuevaCantidad }
          : i
        );
      }
      if (cantidad > producto.stock) return prev;
      return [...prev, { ...producto, cantidad }];
    });
  };

  const eliminar = (id) => setItems(prev => prev.filter(i => i.id !== id));

  const actualizar = (id, cantidad) => {
    if (cantidad <= 0) { eliminar(id); return; }
    setItems(prev => prev.map(i => {
      if (i.id === id) {
        const cantidadFinal = Math.min(cantidad, i.stock);
        return { ...i, cantidad: cantidadFinal };
      }
      return i;
    }));
  };

  const vaciar = () => {
    setItems([]);
    localStorage.removeItem('carrito');
  };

  const total = items.reduce((sum, i) => sum + parseFloat(i.precio) * i.cantidad, 0);
  const totalItems = items.reduce((sum, i) => sum + i.cantidad, 0);

  return (
    <CarritoContext.Provider value={{
      items, agregar, eliminar, actualizar, vaciar,
      total, totalItems,
      carritoAbierto, setCarritoAbierto
    }}>
      {children}
    </CarritoContext.Provider>
  );
};

export const useCarrito = () => useContext(CarritoContext);